export enum UserRoleType {
  ROLE_ADMIN = 'Admin',
  ROLE_SUPERUSER = 'SuperUser',
	ROLE_USER = 'User',

}
